var parent = require('../actual/get-iterator-method');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/full/get-iterator-method.js
// module id = 459
// module chunks = 0 1